import { ParsedUrlQuery } from 'querystring';
import { decodeQueryParams, NumberParam, StringParam, withDefault } from 'serialize-query-params';

import { BLOG_SEARCH_LIMIT } from './blogSearch.constants';

const getBlogSearchPagination = (page = 1) => ({
  offset: (page - 1) * BLOG_SEARCH_LIMIT,
  limit: BLOG_SEARCH_LIMIT,
});

export const getBlogSearchAllPages = (count = 0) => Math.ceil(count / BLOG_SEARCH_LIMIT) || 1;

export const decodeBlogSearchParams = (query: ParsedUrlQuery) => {
  const { blogCategorySlug, page, q } = query;

  const decodedParams = decodeQueryParams(
    {
      page: withDefault(NumberParam, 1),
      categorySlug: withDefault(StringParam, undefined),
      q: withDefault(StringParam, ''),
    },
    { page, categorySlug: blogCategorySlug, q },
  );
  return decodedParams;
};

export const getBlogSearchQuery = (params: { page?: number; q?: string; categorySlug?: string }) => {
  const { page = 1, q, categorySlug } = params;
  const searchQuery = {
    ...getBlogSearchPagination(page),
    category_slug: categorySlug,
    q,
  };
  return searchQuery;
};
